import { getContext } from "@/routes/root";

type OrderSubmittedMessage = {
  type: "orderSubmitted";
  orderId: string;
};

function toOrigin(domain: string): string {
  if (domain.startsWith("http://") || domain.startsWith("https://")) {
    return new URL(domain).origin;
  }
  return `https://${domain}`;
}

export function sendOrderSubmittedPostMessage(orderId: string) {
  if (typeof window === "undefined") return;

  const { frameAncestors = [] } = getContext<{ frameAncestors?: string[] }>();
  if (frameAncestors.length === 0) return;

  const message: OrderSubmittedMessage = {
    type: "orderSubmitted",
    orderId,
  };

  for (const domain of frameAncestors) {
    if (domain.includes("*")) continue;
    window.parent.postMessage(message, toOrigin(domain));
  }
}
